<div class="modal-header">
    <span id="title" class="font-weight-bold">
        {{ "ADDRESS_ADMIN_TASK" | translate }}</span>
        <button type="button" class="close" (click)="dismissModal()">
            <span aria-hidden="true">&times;</span>
        </button>
</div>
<div class="modal-body h-100 pb-0">
    <div class="d-inline-flex">
    <span id="task-overview" class="font-weight-bold my-auto mr-3">
        {{ administrativeTask?.serviceName }} ({{ administrativeTask?.fromTime }}-{{ administrativeTask?.toTime }})
    </span>
    </div>
    <form [formGroup]="addressForm">
        <div class="d-inline-flex mt-3 py-1 w-100 align-content-start">
            <div class="d-inline-flex field w-auto">
                <label class="d-flex my-auto" for="admin-task-address">
                    {{ "ADDRESS" | translate }}
                </label>
                <app-info-tooltip iconSize="sm"
                                  class="ml-1 mr-2 my-auto"
                                  appCustomPopover
                                  popoverText="ADDRESS_VALIDATION_INFO"
                                  placement="top"
                >
                </app-info-tooltip>
            </div>
            <app-form-input-autocomplete
                id="admin-task-address"
                class="ml-2"
                type="search"
                formControlName="address"
                [searching]="validating"
                [readonly]="!editing"
                (changed)="validateAddress()"
                [addressSuggestions]="addressSuggestions"
                appCustomPopover
                placement="right"
                popoverType="error"
                [popoverText]="addressNotValid || validating ? '' : 'ADDRESS_NOT_FOUND' | translate"
            ></app-form-input-autocomplete>
            @if (!editing) {
                <app-tooltip
                    class="my-auto justify-content-start"
                    [delay]="2000"
                    [compact]="true"
                    (click)="editClick()"
                >
                    <ng-container icon>
            <span
                class="vismaicon vismaicon-md vismaicon-edit"
            ></span>
                    </ng-container>
                </app-tooltip>
            }
        </div>
        <div class="d-inline-flex mt-3 py-1 w-100 align-content-start">
            <span class="field my-auto"
            >{{ "ZIP_CODE" | translate }}</span>
            <span>{{ addressForm.controls['zipCode'].value }}</span>
        </div>
        @if (editing) {
            <div class="d-inline-flex justify-content-end w-100 pt-3">
                <button class="btn admin-task-modal-btn btn-primary"
                        type="button"
                        translate="SAVE"
                        [disabled]="!addressForm.valid || !addressNotValid || !submitEnabled || addressForm.value.address.userSelectedOption"
                        (click)="updateAddressClick()"
                >
                </button>
                <button class="btn admin-task-modal-btn btn-secondary"
                        type="button"
                        translate="CANCEL"
                        (click)="dismissModal()">
                </button>
            </div>
        }
        <app-spinner
            [overlay]="true"
            [overlayRounded]="true"
            [visible]="!submitEnabled"
        ></app-spinner>
    </form>
</div>
